import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/cmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/cmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/cmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/cmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/cmain/${Id}`);
  },
};
